import gql from "graphql-tag";

const queryCreate = gql`
  mutation($name: String!, $userIds: [ID!]) {
    createRole(data: { name: $name, userIds: $userIds }) {
      id
      name
      updatedAt
      createdAt
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!, $name: String, $userIds: [ID!]) {
    updateRole(id: $id, data: { name: $name, userIds: $userIds }) {
      id
      name
      users {
        id
        fullname
        username
        email
      }
      updatedAt
      createdAt
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deleteRole(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query {
    getAllRole {
      id
      name
      updatedAt
      createdAt
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getRole(id: $id) {
      id
      name
      updatedAt
      createdAt
      users {
        id
        fullname
        username
        email
      }
      author {
        id
        fullname
      }
    }
  }
`;

export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
};
